import React           from 'react';
import { Observe }     from 'rewire-core';
import RichTextBox     from './RichTextBox';

export default function createRichTextBoxEditor() {
    const Editor = (props: any) => {
      return (
        <Observe render={() => (
          <RichTextBox
            {...props}
          />
          )}
        />
      );
    };
  
    return Editor;
  }